package pwgs.ui.scenes.ensureloggedin

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AEnsureLoggedInControllerFe(props: pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneProps, scene: MEnsureLoggedInScene)
 : AController<pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneProps, pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneModel, EnsureLoggedInSceneState>(props, scene) {

    val backend = EnsureLoggedInControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class EnsureLoggedInControllerBeProxy(private val controller: AEnsureLoggedInControllerFe) {

    suspend fun load(): pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.ensureloggedin.EnsureLoggedInControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneModel.serializer())
        }
    }

}
